<template>
  <span></span>
  <!-- <div class="foot_banner" v-if="(!isInWebview && !isPc && !isIOS)">
    <img
      src="../assets/img/appicon_totok.png"
      alt="download"
      class="totok_logo"
    />
    <p class="banner_titile">{{ t("ToTok - Free HD Video Calls & Voice Chats","ToTok - مكالمات صوتية وفيديو عالية الدقة مجانية") }}</p>
    <a @click="viewDownload" class="get_button">{{t ("Get","تحميل") }} </a>
  </div> -->
</template>

<script>
export default {
  name: "FootBanner",

  data() {
    return {};
  },
  methods:{
    t(d,ar){
      if(this.$route.query.lang == "ar"){
        if(ar != undefined) return ar;
        else return d;
      } else {
        return d;
      }
    },
    viewDownload(){
      //window.gtag("event", "download", {
          //event_category: "downloadpage",
         // event_label: "download",
        //});
      location.href="/download-android?lang=" + this.t("en","ar")
    }
  },
  computed: {
    isInWebview() {
      let ua = window.navigator.userAgent.toLowerCase();
      let currentURL = location.href;
      let result = "";
      if (ua.indexOf("totok") >= 0) {
        result = true;
      } else {
        result = false;
      }
      if (currentURL.indexOf("innerview=1") >= 0) {
        result = true;
      }
      return result;
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
};
</script>

<style lang="stylus" scoped>
.foot_banner{
        position: fixed;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: calc(100vw - 32px);
        height: 40px;
        padding: 12px 16px;
        bottom: 0px;
        z-index: 2;
        background: #f8f8f8;
        margin-right: 0px !important;
        margin-left: 0px !important;

    .totok_logo{
            width: 40px;
    height: 40px;
    }
    .banner_titile{
        font-family: "sofiapro-regular", "Calibri Light", "Helvetica Neue", Roboto, sans-serif;
        font-size: 16px;
        color: #262626;
        width: 208px;
        line-height: 1.2;
        margin: 0px 12px;
    }
    .get_button{
            width: 65px;
    height: 30px;
    background-color: #4378f2;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
    font-size: 15px;
    color: #fff;
    }
}
</style>
